{
  "fr": {
    "partner": {
      "actions": {
        "add": "Ajouter",
        "changeProfilePicture": "Modifier la photo de profil",
        "new": "Partenaire",
        "profilePictureFormat": "Doit être au format carré, au moins 300x300 pixels",
        "save": "Enregistrer",
        "sendinvitation": "Envoyer une invitation",
        "submit": "Enregistrer",
        "undoChanges": "Annuler"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Une fois par jour (vers midi)",
          "hourly": "Toutes les heures",
          "twice_daily": "Deux fois par jour (matin/midi)",
          "weekly": "Une fois par semaine (lundi midi)"
        },
        "first_name": "Prénom",
        "internal_note": "Note interne",
        "language": "Language",
        "last_name": "Nom",
        "phone_landline": "Numéro fixe",
        "phone_mobile": "Numéro de portable",
        "profession": "Profession",
        "session_ended_at": "La visite a commencé à",
        "status": "Status",
        "title": "Titre"
      },
      "labels": {
        "addExistingCompany": "Ajouter à une entreprise existante",
        "contactDetails": "Coordonnées",
        "createNewCompany": "Créez une nouvelle entreprise",
        "information": "Informations sur le profil",
        "newTeamMember": "Nouveau collègue",
        "notEditable": "Certains champs de texte ne sont plus modifiables une fois qu'un partenaire est actif",
        "partnerAddedState": "<b>Pas encore invité.</b> Un e-mail d'invitation sera envoyé une fois que {partner_name} aura accès à une décision publiée, point ou document.",
        "selectedCompany": "Entreprise sélectionnée",
        "start_by_selecting_project": "Commencez par sélectionner un projet sur la gauche"
      },
      "toasts": {
        "create": "Partenaire créé",
        "update": "Partenaire modifié"
      },
      "validation": {
        "mustBeEmailAddress": "Adresse email valide requis",
        "needFirstName": "Prénom requis",
        "needLastName": "Nom réquis",
        "requireEmailAddress": "Address email requis"
      }
    }
  }
}
